export default __webpack_public_path__ + "static/media/slide1.65d20ebf.png";